module.exports = {"id":"206545","name":"Manu Trigueros","rating":"82","photo":"./data/images/photos/4/206545.png","club":{"name":"Villarreal CF","logo":"./data/images/clubs/VillarrealCF.png"},"positions":["MC","MDC","MOC","MG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ManuTrigueros0.json
// module id = 2677
// module chunks = 0